<template>
  <div class="home-know-more">
    <div class="home-text">
      <div class="orange-pos"></div>
      <div class="text-pos">
        <p class="p1 bold wow fadeInUp" data-wow-delay="0.5s">
          {{ $t("home.iamgwmora") }}
        </p>
        <div class="p2">
          <p class="wow fadeInUp" data-wow-delay="0.5s">
            <!-- {{ $t("home.onroadalways") }} -->
            {{ $t("home.on") }}
            <span class="bold">{{ $t("home.road") }}</span>
            {{ $t("home.always") }}
          </p>
          <img
            src="@/assets/images/ora_logo.png"
            class="wow fadeInUp"
            data-wow-delay="0.5s"
            alt=""
          />
        </div>

        <div
          class="know-more wow fadeInUp"
          data-wow-delay="0.5s"
          @click="$router.push('/brand')"
        >
          <span class="bold">{{ $t("home.knowmore") }}</span>
          <img src="@/assets/images/know-right.png" alt="" />
        </div>
      </div>
    </div>
    <div class="home-pic">
      <img
        src="@/assets/images/home-know.png"
        class="hidden-md"
        data-wow-delay="0.5s"
        alt=""
      />
      <img
        src="@/assets/images/two-person.png"
        class="visible-md"
        data-wow-delay="0.5s"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
export default {
  mounted() {
    new WOW().init();
  },
};
</script>

<style lang="scss" scoped>
.p1 {
  color: #333;
  font-size: 60px;
}
.p2 {
  display: flex;
  color: #333;
  font-size: 50px;
  align-items: center;
  font-weight: 900;
  img {
    width: 30px;
    margin-left: 8px;
  }
}
.home-know-more {
  display: flex;
  background: #fff;
  // padding: 200px 0 160px 0;
  padding: 120px 0;
  cursor: pointer;
  .home-text {
    position: relative;
    width: 55%;
    .orange-pos {
      position: absolute;
      right: 0;
      top: 0;
      height: 100%;
      width: 30%;
      background: #ff8a3b;
      border-top: 1px solid #000;
      border-left: 1px solid #000;
      border-bottom: 1px solid #000;
    }
  }
  .home-pic {
    width: 45%;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.text-pos {
  position: relative;
  text-align: left;
  top: 20%;
  left: 30%;
}
.know-more {
  width: 35%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border: 1px solid #333333;
  box-sizing: border-box;
  border-radius: 50px;
  padding: 20px 0px;
  margin-top: 30px;
  span {
    font-size: 20px;
    color: #333;
  }
  img {
    width: 25px;
    margin-left: 20px;
  }
}
@media (max-width: 1450px) {
}
@media (max-width: 1200px) {
  .know-more {
    span {
      font-size: 16px;
      color: #333;
    }
    img {
      width: 25px;
      margin-left: 10px;
    }
  }
}
@media (max-width: 767px) {
  .text-pos {
    width: 90%;
    position: relative;
    text-align: left;
    top: 20%;
    left: 0%;
    right: 0%;
    margin: 0 auto;
  }
  .p1 {
    color: #333;
    font-size: 42px;
    @media (max-width: 375px) {
      font-size: 39px;
    }
  }
  .p2 {
    display: flex;
    color: #333;
    font-size: 26px;
    align-items: center;
    img {
      width: 18px;
      //   margin-left: 5px;
    }
  }
  .home-know-more {
    display: block;
    background: #fff;
    padding: 0px;
    padding: 85px 0 0px 0;
    .home-text {
      position: relative;
      width: 100%;
      padding: 64px 0 60px 0;
      .orange-pos {
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;
        width: 50%;
        background: #ff8a3b;
        border-bottom: 0px solid #000;
      }
    }
    .home-pic {
      width: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .know-more {
    width: 210px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border: 1px solid #333333;
    box-sizing: border-box;
    border-radius: 50px;
    padding: 10px 0px;
    margin-top: 30px;
    span {
      font-size: 18px;
      color: #333;
    }
    img {
      width: 25px;
      margin-left: 10px;
    }
  }
}
</style>